import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class SuiteErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[ITaaS Suite]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="suite-center-message">
          <div className="suite-login-card text-start">
            <h1 className="h5 text-danger mb-2">Erreur d&apos;affichage</h1>
            <p className="text-muted small mb-3">
              {this.state.error.message || "Une erreur inattendue s'est produite."}
            </p>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => window.location.reload()}
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
